import { ILop } from "../../../model/respone/category/ILop";
import { eLopActionTypeIds } from "../../action-types/category/ILopActionType";
import { baseAction } from "../IActionBase";

export const lopAction = {
    loadStart: () => baseAction(eLopActionTypeIds.LOAD_START, undefined),
    loadSuccess: (data: ILop[]) => baseAction(eLopActionTypeIds.LOAD_SUCCESS, data),
    loadError: (message?: string) => baseAction(eLopActionTypeIds.LOAD_ERROR, message),
}